import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';

//import phoneImg from '../../../assest/Solutions-Token/Intro.png';
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import benefits from '../../../assest/Solutions-Token/Benefits new.jpg';
import './data-tokenization.scss';
import { OverlapBoxFeature } from '../features-page/features-page.component';
import global from '../../../assest/Solutions-Token/What can be Tokenized 2 (1).jpg';
//import global1 from '../../../assest/Solutions-Token/Token Transparent (2).png';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';

// Static imports
import Intro_US from '../../../assest/Solutions-Token/Intro.png';
import Intro_GB from '../../../assest/Solutions-Token/Intro_GB.png';

import global_US from '../../../assest/Solutions-Token/Token Transparent (2).png';
import global_GB from '../../../assest/Solutions-Token/global_GB.png';

export const DataTokenization = () => {
  const { t } = useTranslation('data-tokenization');
  const phoneImageMap = {
    Intro_US,
    Intro_GB,
  };

  const selectedPhoneImageKey = t('phoneImageKey'); // From JSON
  const phoneImg = phoneImageMap[selectedPhoneImageKey] || Intro_US;

  const globalImageMap = {
    global_US,
    global_GB,
  };

  const selectedGlobalImageKey = t('globalImageKey'); // From JSON
  const global1 = globalImageMap[selectedGlobalImageKey] || Intro_US;
  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('pageTitle')} uris={t('pageUri')} />

      <OverlapBoxTechno img={phoneImg} title={t('introTitle')}>
        <TrackedSection sectionName="DataTokenizationPage AdvancedData">
          <p>{t('introPara1')}</p>
          <p>{t('introPara2')}</p>
          <p>{t('introPara3')}</p>
        </TrackedSection>
      </OverlapBoxTechno>

      <SectionRight
        title={t('section1Title')}
        title1={t('section1Title1')}
        content1={t('section1Content1')}
        title2={t('section1Title2')}
        content2={t('section1Content2')}
        title3={t('section1Title3')}
        content3={t('section1Content3')}
        title4={t('section1Title4')}
        content4={t('section1Content4')}
        imgPath={global}
        customClass="feature-box-imagesdt"
      />

      <SectionRight
        title={t('section2Title')}
        desc={t('section2Desc')}
        title1={t('section2Title1')}
        content1={t('section2Content1')}
        title2={t('section2Title2')}
        content2={t('section2Content2')}
        imgPath={global1}
        customClass="feature-box-imagedt"
      />

      <OverlapBoxFeature title={t('benefitsTitle')}>
        <TrackedSection sectionName="DataTokenizationPage SolutionBenefits">
          <EarthidBox t={t} />
        </TrackedSection>
      </OverlapBoxFeature>

      <Getstarted />
      <Footer />
    </div>
  );
};

const HeaderHalf = ({ title, uris }) => (
  <div className='headerHalf-main-distributdt'>
    <div className='headerHalf-content'>
      <p className='headerHalf-title'>{title}</p>
      <p className='headerHalf-uris'>Solutions / <span className='uris-class'>{uris}</span></p>
    </div>
  </div>
);

const KYSCard = ({ icon, desc, title }) => (
  <div className='kys-card'>
    <div><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
    <div className="key-text-col">
      <p className='kys-card-title'>{title}</p>
      <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
    </div>
  </div>
);

const EarthidBox = ({ t }) => (
  <div className='kys-div'>
    <div className='kys-platform-content'>
      <KYSCard icon={kysBulletPoint} title={t('benefit1Title')} desc={t('benefit1Desc')} />
      <KYSCard icon={kysBulletPoint} title={t('benefit2Title')} desc={t('benefit2Desc')} />
      <KYSCard icon={kysBulletPoint} title={t('benefit3Title')} desc={t('benefit3Desc')} />
    </div>
    <div className='kys-platform-content'>
      <KYSCard icon={kysBulletPoint} title={t('benefit4Title')} desc={t('benefit4Desc')} />
      <KYSCard icon={kysBulletPoint} title={t('benefit5Title')} desc={t('benefit5Desc')} />
      <KYSCard icon={kysBulletPoint} title={t('benefit6Title')} desc={t('benefit6Desc')} />
    </div>
    <div className='kys-platform-img'>
      <img src={benefits} className='kys-platform-imagee' alt='kysCardIcon' />
    </div>
  </div>
);

const OverlapBoxTechno = ({ img, title, children }) => (
  <div className='overlap-box-technoo'>
    <img src={img} alt='phone-img' className='techno-imgDT' />
    <div className='techno-content'>
      <p className='techno-title'>{title}</p>
      <div className='rest-para'>{children}</div>
    </div>
  </div>
);

const SectionRight = props => (
  <div className='feature-box-rights'>
    <p className='title-feature'>{props.title}</p>
    {props.desc && <p className='desc1-feature'>{props.desc}</p>}
    <div className="kys-div">
      <div className='kys-platform-content'>
        {props.title1 && props.content1 && <KYSCard icon={kysBulletPoint} title={props.title1} desc={props.content1} />}
        {props.title2 && props.content2 && <KYSCard icon={kysBulletPoint} title={props.title2} desc={props.content2} />}
        {props.title3 && props.content3 && <KYSCard icon={kysBulletPoint} title={props.title3} desc={props.content3} />}
        {props.title4 && props.content4 && <KYSCard icon={kysBulletPoint} title={props.title4} desc={props.content4} />}
      </div>
      <div className={`kys-platform-imgdt`}>
        <img src={props.imgPath} className='kys-platform-imageedt' alt="feature-img" />
      </div>
    </div>
  </div>
);
